import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ViewComponent } from './view/view.component';
import { IsLoggedInGuard } from './guard/is-logged-in.guard';
import { SearchComponent } from './search/search.component';
import { SbusinessComponent } from './search/sbusiness/sbusiness.component';
import { VbusinessComponent } from './view/vbusiness/vbusiness.component';
import { SblogComponent } from './search/sblog/sblog.component';
import { CreateComponent } from './create/create.component';
import { CbusinessComponent } from './create/cbusiness/cbusiness.component';
import { VblogComponent } from './view/vblog/vblog.component';
import { PageComponent } from './page/page.component';
import { PaboutComponent } from './page/pabout/pabout.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { MyactivityComponent } from './myactivity/myactivity.component';
import { MyComponent } from './my/my.component';
import { LogoutComponent } from './logout/logout.component';
import { MailhomeComponent } from './mailhome/mailhome.component';
import { MphotoComponent } from './my/mphoto/mphoto.component';
import { MvideoComponent } from './my/mvideo/mvideo.component';
import { MblogComponent } from './my/mblog/mblog.component';
import { MeventComponent } from './my/mevent/mevent.component';
import { MbusinessComponent } from './my/mbusiness/mbusiness.component';
import { MaudioComponent } from './my/maudio/maudio.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VphotoComponent } from './view/vphoto/vphoto.component';
import { VvideoComponent } from './view/vvideo/vvideo.component';
import { VaudioComponent } from './view/vaudio/vaudio.component';
import { CphotoComponent } from './create/cphoto/cphoto.component';
import { CvideoComponent } from './create/cvideo/cvideo.component';
import { CaudioComponent } from './create/caudio/caudio.component';
import { CblogComponent } from './create/cblog/cblog.component';
import { MgroupComponent } from './my/mgroup/mgroup.component';
import { CgroupComponent } from './create/cgroup/cgroup.component';
import { EphotoComponent } from './edit/ephoto/ephoto.component';
import { EditComponent } from './edit/edit.component';
import { EvideoComponent } from './edit/evideo/evideo.component';
import { EaudioComponent } from './edit/eaudio/eaudio.component';
import { EbusinessComponent } from './edit/ebusiness/ebusiness.component';
import { EblogComponent } from './edit/eblog/eblog.component';
import { EgroupComponent } from './edit/egroup/egroup.component';
import { SphotoComponent } from './search/sphoto/sphoto.component';
import { SvideoComponent } from './search/svideo/svideo.component';
import { SaudioComponent } from './search/saudio/saudio.component';
import { PprivacyComponent } from './page/pprivacy/pprivacy.component';
import { PtosComponent } from './page/ptos/ptos.component';
import { MalbumComponent } from './my/malbum/malbum.component';
import { MchannelComponent } from './my/mchannel/mchannel.component';
import { MplayListComponent } from './my/mplay-list/mplay-list.component';
import { CalbumComponent } from './create/calbum/calbum.component';
import { CchannelComponent } from './create/cchannel/cchannel.component';
import { CplaylistComponent } from './create/cplaylist/cplaylist.component';
import { ValbumComponent } from './view/valbum/valbum.component';
import { VchannelComponent } from './view/vchannel/vchannel.component';
import { VplayListComponent } from './view/vplay-list/vplay-list.component';
import { EalbumComponent } from './edit/ealbum/ealbum.component';
import { EchannelComponent } from './edit/echannel/echannel.component';
import { EplayListComponent } from './edit/eplay-list/eplay-list.component';
import { SchannelComponent } from './search/schannel/schannel.component';
import { SplaylistComponent } from './search/splaylist/splaylist.component';
import { SalbumComponent } from './search/salbum/salbum.component';
import { PtermsComponent } from './page/pterms/pterms.component';
import { SeventComponent } from './search/sevent/sevent.component';
import { CeventComponent } from './create/cevent/cevent.component';
import { ChatsComponent } from './chats/chats.component';
import { CchatlistComponent } from './chats/cchatlist/cchatlist.component';
import { FactivitiesComponent } from './friend/factivities/factivities.component';
import { VeventComponent } from './view/vevent/vevent.component';
import { MeducationComponent } from './my/meducation/meducation.component';
import { MsportsComponent } from './my/msports/msports.component';
import { MworkComponent } from './my/mwork/mwork.component';
import { CeducationComponent } from './create/ceducation/ceducation.component';
import { CsportComponent } from './create/csport/csport.component';
import { CworkComponent } from './create/cwork/cwork.component';
import { ChronologymemberComponent } from './chronology/chronologymember/chronologymember.component';
import { VmemberComponent } from './view/vmember/vmember.component';
import { SworkComponent } from './search/swork/swork.component';
import { SeducationComponent } from './search/seducation/seducation.component';
import { SsportsComponent } from './search/ssports/ssports.component';
import { FaudioComponent } from './friend/faudio/faudio.component';
import { FvideoComponent } from './friend/fvideo/fvideo.component';
import { FphotoComponent } from './friend/fphoto/fphoto.component';
import { FblogComponent } from './friend/fblog/fblog.component';
import { FgroupComponent } from './friend/fgroup/fgroup.component';
import { FproductComponent } from './friend/fproduct/fproduct.component';
import { EeventComponent } from './edit/eevent/eevent.component';
import { SproductComponent } from './search/sproduct/sproduct.component';
import { MproductComponent } from './my/mproduct/mproduct.component';
import { CproductComponent } from './create/cproduct/cproduct.component';
import { EproductComponent } from './edit/eproduct/eproduct.component';
import { VproductComponent } from './view/vproduct/vproduct.component';
import { CartlistComponent } from './cart/cartlist/cartlist.component';
import { PaymentComponent } from './payment/payment.component';
import { AudiorecordComponent } from './audiorecord/audiorecord.component';
import { Record1Component } from './record1/record1.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { SpollComponent } from './search/spoll/spoll.component';
import { VpollComponent } from './view/vpoll/vpoll.component';
import { PollResultComponent } from './poll-result/poll-result.component';
import { MpollComponent } from './my/mpoll/mpoll.component';
import { CpollComponent } from './create/cpoll/cpoll.component';
import { EpollComponent } from './edit/epoll/epoll.component';
import { TappsComponent } from './timeline/tapps/tapps.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'record', component: AudiorecordComponent },
  { path: 'get-started', component: GetStartedComponent },
  { path: 'record1', component: Record1Component },
  { path: 'poll-result/:title', component: PollResultComponent },
  { path: 'business/:title', component: VbusinessComponent },
  { path: 'product/:title', component: VproductComponent },
  { path: 'event/:title', component: VeventComponent },
  { path: 'timeline/:title', component: TappsComponent },
  { path: 'album/:title', component: ValbumComponent },
  { path: 'channel/:title', component: VchannelComponent },
  { path: 'playList/:title', component: VplayListComponent },
  { path: 'photo/:title', component: VphotoComponent },
  { path: 'poll/:title', component: VpollComponent },
  { path: 'audio/:title', component: VaudioComponent },
  { path: 'video/:title', component: VvideoComponent },
  { path: 'blog/:title', component: VblogComponent },
  { path: 'cart', component: CartlistComponent },
  { path: 'payment', component: PaymentComponent },
  { path: 'tos', component: PtosComponent },
  { path: 'privacy', component: PprivacyComponent },
  { path: 'about', component: PaboutComponent },
  { path: 'terms', component: PtermsComponent },
  { path: 'chat',  canActivate:[IsLoggedInGuard], component: CchatlistComponent },
  { path: 'chats',  canActivate:[IsLoggedInGuard], component: ChatsComponent },
  { path: 'mail',  canActivate:[IsLoggedInGuard], component: MailhomeComponent },
  { path: 'chronology/member', component: ChronologymemberComponent },
  { path: 'friend/activities', component: FactivitiesComponent },
  { path: 'friend/audio', component: FaudioComponent },
  { path: 'friend/video', component: FvideoComponent },
  { path: 'friend/photo', component: FphotoComponent },
  { path: 'friend/blog', component: FblogComponent },
  { path: 'friend/group', component: FgroupComponent },
  { path: 'friend/product', component: FproductComponent },
  { path: 'my/product', canActivate:[IsLoggedInGuard], component: MproductComponent },
  { path: 'my/sports', canActivate:[IsLoggedInGuard], component: MsportsComponent },
  { path: 'my/work', canActivate:[IsLoggedInGuard], component: MworkComponent },
  { path: 'my/education', canActivate:[IsLoggedInGuard], component: MeducationComponent },
  { path: 'my/channel',  canActivate:[IsLoggedInGuard], component: MchannelComponent },
  { path: 'my/album',  canActivate:[IsLoggedInGuard], component: MalbumComponent },
  { path: 'my/playList', canActivate:[IsLoggedInGuard], component: MplayListComponent },
  { path: 'my/poll', canActivate:[IsLoggedInGuard], component: MpollComponent },
  { path: 'my/photo',  canActivate:[IsLoggedInGuard],component: MphotoComponent },
  { path: 'my/video', canActivate:[IsLoggedInGuard], component: MvideoComponent },
  { path: 'my/group',  canActivate:[IsLoggedInGuard],component: MgroupComponent },
  { path: 'my/blog',  canActivate:[IsLoggedInGuard],component: MblogComponent },
  { path: 'my/audio',  canActivate:[IsLoggedInGuard],component: MaudioComponent },
  { path: 'my/event',  canActivate:[IsLoggedInGuard],component: MeventComponent },
  { path: 'my/business', canActivate:[IsLoggedInGuard], component: MbusinessComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'login', component: LoginComponent },
  { path: 'register', component: RegisterComponent },
  {
    path: 'view', component: ViewComponent,
    children: [
      { path: 'member', component: VmemberComponent }
    ]
  },
  {
    path: 'create',  canActivate:[IsLoggedInGuard], component: CreateComponent,
    children: [
      { path: 'education', component: CeducationComponent },
      { path: 'sports', component: CsportComponent },
      { path: 'poll', component: CpollComponent },
      { path: 'work', component: CworkComponent },
      { path: 'product', component: CproductComponent },
      { path: 'business', component: CbusinessComponent },
      { path: 'event', component: CeventComponent },
      { path: 'album', component: CalbumComponent },
      { path: 'channel', component: CchannelComponent },
      { path: 'playList', component: CplaylistComponent },
      { path: 'audio', component: CaudioComponent },
      { path: 'video', component: CvideoComponent },
      { path: 'blog', component: CblogComponent },
      { path: 'group', component: CgroupComponent },
      { path: 'photo', component: CphotoComponent }
    ]
  },
  {
    path: 'edit',  canActivate:[IsLoggedInGuard],component: EditComponent,
    children: [
      { path: 'product', component: EproductComponent },
      { path: 'poll', component: EpollComponent },
      { path: 'evenet', component: EeventComponent },
      { path: 'business', component: EbusinessComponent },
      { path: 'audio', component: EaudioComponent },
      { path: 'video', component: EvideoComponent },
      { path: 'blog', component: EblogComponent },
      { path: 'group', component: EgroupComponent },
      { path: 'album', component: EalbumComponent },
      { path: 'channel', component: EchannelComponent },
      { path: 'playList', component: EplayListComponent },
      { path: 'photo', component: EphotoComponent }
    ]
  },
  { path: 'product', component: SproductComponent },
  { path: 'business', component: SbusinessComponent },
  { path: 'event', component: SeventComponent },
  { path: 'blog', component: SblogComponent },
  { path: 'playList', component: SplaylistComponent },
  { path: 'channel', component: SchannelComponent },
  { path: 'work', component: SworkComponent },
  { path: 'education', component: SeducationComponent },
  { path: 'sports', component: SsportsComponent },
  { path: 'album', component: SalbumComponent },
  { path: 'video', component: SvideoComponent },
  { path: 'audio', component: SaudioComponent },
  { path: 'photo', component: SphotoComponent },
  { path: 'poll', component: SpollComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'myactivity', component: MyactivityComponent },
  { path: 'my', component: MyComponent },
  { path: 'home', component: HomeComponent },
  { path: '**', component: HomeComponent }
];


@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
